export default {
  iconTextItem: ['総計', 'アイコン'],
}
